export const SOCIAL_AUTH_SAVE_DATA = 'save-data';
